import apiClient from '../config/axiosConfig';
import { API_BASE_URL } from '../utils/apiUtils';

/**
 * Create a team user with team - Admin only
 * POST /api/admin-setup/users/create-team-user
 * @param {Object} userData - { email, password, fullName, teamName, teamDescription, teamPhoneNumber, teamAddress, sendWelcomeEmail }
 * @returns {Promise<Object>} Created user, team, and credentials
 */
export const createTeamUser = async (userData) => {
    try {
        const { email, password, fullName, teamName, teamDescription, teamPhoneNumber, teamAddress, sendWelcomeEmail, maxTeamMembers } = userData;

        // Validation
        if (!email || !password || !fullName || !teamName) {
            throw new Error('Email, password, full name, and team name are required');
        }

        const response = await apiClient.post(
            `${API_BASE_URL}/api/admin-setup/users/create-team-user`,
            {
                email: email.trim().toLowerCase(),
                password: password,
                fullName: fullName.trim(),
                teamName: teamName.trim(),
                teamDescription: teamDescription ? teamDescription.trim() : '',
                teamPhoneNumber: teamPhoneNumber ? teamPhoneNumber.trim() : undefined,
                teamAddress: teamAddress ? teamAddress.trim() : undefined,
                sendWelcomeEmail: sendWelcomeEmail !== undefined ? sendWelcomeEmail : true,
                maxTeamMembers: maxTeamMembers
            }
        );

        return response.data;
    } catch (error) {
        console.error('[AdminAPI] Error creating team user:', error);

        if (error.response) {
            // Server responded with error
            const errorMessage = error.response.data?.message || error.response.data?.error || 'Failed to create team user';
            throw new Error(errorMessage);
        } else if (error.request) {
            // Request made but no response
            throw new Error('Network error. Please check your connection and try again.');
        } else {
            // Error in request setup
            throw new Error(error.message || 'An unexpected error occurred');
        }
    }
};

